module.exports = __webpack_public_path__ + "img/Web Developer.9d27e68a.png";